import React, { Component } from 'react';
import AdminFunctions from '../admin/AdminFunctions';
import AccountFunctions from '../services/AccountService';
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FaSort } from 'react-icons/fa'
import '../layout/site.css';
import Modal from 'react-bootstrap/Modal';
import Session from '../auth/Session';
import AuthFunctions from '../services/AuthService';

export class CustomerService extends Component {
    static displayName = CustomerService.name;

    constructor(props) {
        super(props);

        this.state = {
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            showToast: false,
            subject: '',
            message: '',
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.sites.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    handleClose() {
        this.setState({ show: false, showToast: false });
    }

    handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.sites.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.sites.length / pageSize) })
        }
    }

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";

        this.setWindowDimensions();
        const isAdmin = await AdminFunctions.isAdminAsync();
        this.setState({ isAdmin: isAdmin });
        if (isAdmin) {

        }
        else {
        }
    }

    setWindowDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    };

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            //this.searchSites();
        }
    }

    async handleSubmission() {
        var data = { subject: this.state.subject, message: this.state.message };

        var response = await AccountFunctions.postCustomerSupportRequestAsync(data);

        if (response != null) {
            this.setState({ showToast: true, subject: '', message: '' });
        }
    };


    render() {
        //Put in logic here! 

        return (
            <div>
                <Container>
                    <Row>
                        <Col>
                            <h2 style={{ color: '#233c7c' }}>Customer Service</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                                    {/*TODO: Update verbiage from Cynthia*/}
                                    <span>We're here to help</span>
                            
                            
                            <Input
                                type='text'
                                onChange={(e) => this.setState({ subject: e.target.value })}
                                value={this.state.subject}
                                className='smallInput'
                                placeholder='Subject'
                            />
                            <textarea
                                className='form-control marginTop'
                                onChange={(e) => this.setState({ message: e.target.value })}
                                value={this.state.message}
                                name='Message'
                                id='Message'
                                placeholder='Message'
                                
                            />
                            <Button
                                color='primary'
                                className='standardButton marginTop'
                                onClick={() => this.handleSubmission()}
                                disabled={this.state.loading ? true : false}
                            >
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Container>
                <Modal show={this.state.showToast} onHide={this.handleClose}>
                    <Modal.Header >
                        <Modal.Title>Email Sent!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Thank you for reaching out to <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span>.  A team member will be in contact with you shortly.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
           </div>
        )
    }


    // table sort
    GetIdFromQuery(location) {
        //#!?lid=2&sales=2
        var id = location.search().Id;
        if (id == null) return 0;
        else return id;
    }

    async handleSave() {
        debugger
        const token = Session.getToken();
        var dto = this.state.site;
        await this.saveSite(dto, token);
    }

    async saveSite(dto, token) {
        //const response = await fetch('api/Sites/SaveSite', {
        //    method: 'POST',
        //    body: JSON.stringify(dto),
        //    headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        //});
        //const data = await response.json();
        //this.setState({ success: data });
    }
}